import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'apm-sidebar',
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApmSidebarComponent {
  @HostBinding('class') class = 'apm-sidebar h-100 d-flex flex-column';
}
